export const KEYBOARD_COMMAND_NAMES = {
  NEXT_SUBFIELD: 'NEXT_SUBFIELD',
  PREV_SUBFIELD: 'PREV_SUBFIELD',
};

export const keyboardCommands = [
  {
    name: KEYBOARD_COMMAND_NAMES.NEXT_SUBFIELD,
    shortcut: 'ctrl+]',
  },
  {
    name: KEYBOARD_COMMAND_NAMES.PREV_SUBFIELD,
    shortcut: 'ctrl+[',
  },
];
